export default __webpack_public_path__ + "static/media/Lip_2_M.8a2a0ca5.svg";